const useDialogStore = defineStore('dialog', () => {
    // Data
    const dialog = ref<string | null>();
    const options = ref<{ [key: string]: any }>({});

    // Computed
    const component = computed(() => {
        if (!dialog.value) {
            return null;
        }

        return defineAsyncComponent(() => import(`@/pages/page/dialogs/${dialog.value}/${dialog.value}.vue`));
    });

    // Methods
    const open = (name: string, params: { [key: string]: any } = {}): void => {
        dialog.value = name;
        options.value = params;
    };

    const close = (): void => {
        dialog.value = null;
        options.value = {};
    };

    return {
        dialog,
        options,
        component,
        open,
        close,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useDialogStore, import.meta.hot));
}

export default useDialogStore;
